import { useEffect, useRef, useState, useCallback } from "react";

export const useLoginBanner = (
    totalItems = 0,
    intervalTime = 5000,
    fadeTime = 400
) => {
    const [bannerIndex, setBannerIndex] = useState(0);
    const [fade, setFade] = useState(true);

    const timeoutRef = useRef(null);
    const intervalRef = useRef(null);

    const clearTimers = useCallback(() => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);

    const runTransition = useCallback((nextIndex) => {
        setFade(false);

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            setBannerIndex(nextIndex);
            setFade(true);
        }, fadeTime);
    }, [fadeTime]);

    const goToSlide = (index) => {
        if (!totalItems || index < 0 || index >= totalItems || index === bannerIndex) {
            return;
        }

        runTransition(index);
    };

    useEffect(() => {
        if (!totalItems || totalItems <= 1) {
            setBannerIndex(0);
            setFade(true);
            clearTimers();
            return;
        }

        intervalRef.current = setInterval(() => {
            const nextIndex = (bannerIndex + 1) % totalItems;
            runTransition(nextIndex);
        }, intervalTime);

        return () => {
            clearTimers();
        };
    }, [bannerIndex, totalItems, intervalTime, clearTimers, runTransition]);

    return {
        bannerIndex,
        fade,
        goToSlide,
    };
};
